module.exports = __webpack_public_path__ + "static/media/logo_u_cuc.2ad5d384.png";